<template>
  <Fade :delay="0" :duration="300">
    <div v-if="!$store.state.loaded" class="preloader row middle-xs">
      <div class="center col-xs-3 logo">
        <LandingLogo
          :options="defaultOptions"
          v-on:animCreated="handleAnimation"
          class="preloaderLogo"
        />
        <h3 class="loadingText">L O A D I N G</h3>
        <p class="loadingText">One moment, please.</p>
      </div>
    </div>
  </Fade>
</template>

<script>
import LandingLogo from "@/transitions/LandingLogo.vue";
import Fade from "@/transitions/Fade.vue";
import * as animationData from "../assets/Logo_Blue.json";
export default {
  name: "Preloader",
  components: {
    LandingLogo,
    Fade
  },
  data() {
    return {
      defaultOptions: {
        animationData: animationData.default,
        rendererSettings: {
          preserveAspectRatio: "xMidYMin"
        }
      }
    };
  },
  mounted() {
    let Vue = this;
    window.onload = function() {
      // setTimeout(function() {
      Vue.$store.state.loaded = true;
      // }, 2000);
    };
  },
  methods: {
    handleAnimation: function(anim) {
      this.anim = anim;
      anim.loop = true;
      anim.play();
    }
  }
};
</script>

<style lang="scss" scoped>
.preloader {
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: $light-grey;
  z-index: 9999;
  overflow: hidden;
  justify-content: center;
  vertical-align: center;
  .loadingText {
    margin-top: 1rem;
    text-align: center;
    overflow: none;
    color: $almost-black;
  }
}
.preloaderLogo {
  max-height: 33vh;
  vertical-align: center;
  margin: 0 auto;
  @include respond-to(md) {
    max-width: 200px;
  }
}
</style>
